import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import './index.css';
import { getJobDetails } from '../../Services/resupply';

const Redirection = () => {
    const navigate = useNavigate();
    const { hs_object_id } = useParams();
    const [loading, setLoading] = useState(true);
    const [jobData, setJobData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('No authentication token found');
                }

                const res = await getJobDetails(token, hs_object_id);
                if (res && res?.data) {
                    if (res?.data?.status == 200) {
                        let dealId = res?.data?.data?.[0]?.HS_Deal_ID
                        let detailsId = res?.data?.data?.[0]?.JobDetails_ID
                        let country = res?.data?.data?.[0]?.country
                        let Resupply_Request_ID = res?.data?.data?.[0]?.Resupply_Request_ID
                        if (res?.data?.data[0]?.IsActive == "False") {
                            navigate(`/home/${dealId}/${country}?requestType=Resupply&jobDetailsId=${detailsId}`)
                        } else {

                            navigate(`/home/${detailsId}/${Resupply_Request_ID}/${dealId}/${country}`)
                        }
                    }

                }
                //  setJobData(res.data);
                //setLoading(false);
            } catch (err) {
                console.error('Failed to fetch job details:', err);
                setError(err.message || 'Something went wrong');
                setLoading(false);
            }
        };

        fetchJobDetails();
    }, [hs_object_id]);

    // --- Loading State ---
    if (loading) {
        return (
            <div className="redirection-container loading-container">
                <div className="spinner"></div>
                <p className="loading-text">Redirecting…</p>
            </div>
        );
    }

    // --- Error State ---
    if (error) {
        return (
            <div className="redirection-container error-container">
                <div className="error-card">
                    <h2>⚠️ Oops!</h2>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    // --- Success State ---
    return (
        <div className="redirection-container">
            {/* <div className="details-card">
                <h1>Job Details</h1>
                {jobData ? (
                    <div className="job-info">
                        {Object.entries(jobData).map(([key, value]) => (
                            <div key={key} className="info-row">
                                <span className="info-key">{key}</span>
                                <span className="info-value">
                                    {typeof value === 'object' ? JSON.stringify(value) : value}
                                </span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No data available</p>
                )}
            </div> */}
        </div>
    );
};

export default Redirection;